import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const laneAdditionalChargeRateTypesAdapter = getAdapter({ idFieldName: 'value' });

const laneAdditionalChargeRateTypesSlice = createSlice({
  name: 'laneAdditionalChargeRateTypes',
  initialState: laneAdditionalChargeRateTypesAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setLaneAdditionalChargeRateTypes: (state, { payload: { laneAdditionalChargeRateTypes, source } }) => {
      laneAdditionalChargeRateTypesAdapter.setAll(state, laneAdditionalChargeRateTypes);
      state.source = source;
    },
  },
});

const selectors = laneAdditionalChargeRateTypesAdapter.getSelectors(({ laneAdditionalChargeRateTypes }) => laneAdditionalChargeRateTypes);

export const getLaneAdditionalChargeRateTypes = (state) => selectors.selectAll(state);

export const { setLaneAdditionalChargeRateTypes } = laneAdditionalChargeRateTypesSlice.actions;

export default laneAdditionalChargeRateTypesSlice.reducer;
